import React from "react"
import styled from "styled-components"
import TrayectoriaTimeline from "./trayectoria-timeline"

const MissionSectionWrapper = styled.section`
  background-color: #f3f3f3;
  padding: 80px 0 60px 0;
`

const MissionGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.4fr);
  grid-gap: 3em;
  align-items: flex-start;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`

const MissionLeft = styled.div``

const MissionRight = styled.div``

const MissionPageLabel = styled.span`
  display: inline-block;
  margin-bottom: 12px;
  font-family: var(--font-md);
  font-size: 0.85em;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--third-color);

  &::before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 8px;
    background-color: var(--primary-color);
  }
`

const MissionTitle = styled.h2`
  margin: 0 0 16px 0;
  font-family: var(--font-bold);
  font-size: 2.1em;
  color: var(--primary-color);
`

const MissionIntro = styled.p`
  margin: 0;
  font-family: var(--font-md);
  font-size: 1em;
  color: var(--six-color);
  line-height: 1.8em;
`

const MissionTimeline = styled.div`
  position: relative;
  margin-top: 8px;
  padding-left: 32px;

  &::before {
    content: "";
    position: absolute;
    top: 24px;
    bottom: 0;
    left: 22px;
    width: 2px;
    background-color: var(--primary-light-color);
  }
`

const MissionTimelineItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 16px;
  align-items: flex-start;
  margin-top: 24px;
`

const StepCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 3px solid var(--primary-light-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-bold);
  font-size: 1.1em;
  color: var(--primary-color);
  z-index: 1;
`

const MissionStepContent = styled.div``

const MissionStepTitle = styled.h3`
  margin: 0 0 6px 0;
  font-family: var(--font-bold);
  font-size: 1.05em;
  color: var(--six-color);
`

const MissionStepText = styled.p`
  margin: 4px 0 0 0;
  font-family: var(--font-md);
  font-size: 0.95em;
  color: var(--six-color);
  line-height: 1.7em;
`

const TrayectoriaSectionWrapper = styled.section`
  background-color: var(--primary-color);
  padding: 70px 0 80px 0;
`

const TrayectoriaHeader = styled.h2`
  margin: 0 0 24px 0;
  font-family: var(--font-bold);
  font-size: 2.1em;
  color: var(--four-color);
`

const TrayectoriaStatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 32px;
`

const StatPill = styled.div`
  padding: 8px 18px;
  border-radius: 999px;
  font-family: var(--font-bold);
  font-size: 0.95em;
  background-color: #ffffff;
  color: var(--six-color);
`

const MissionTrayectoriaSectionNew = () => {
  const missionSteps = [
    {
      step: "01",
      title: "Consultoría en dictámenes técnicos",
      text:
        "Ofrecemos asesoría en la evaluación técnica de proyectos, asegurando su viabilidad y cumplimiento normativo",
    },
    {
      step: "02",
      title: "Elaboración de Estudios Financieros",
      text:
        "Elaboramos análisis financieros que evalúan la rentabilidad y los riesgos de cada proyecto",
    },
    {
      step: "03",
      title: "Estructuración de proyectos de inversión",
      text:
        "Diseñamos estructuras financieras eficientes para proyectos de inversión, alineando recursos y objetivos",
    },
  ]

  return (
    <>
      <MissionSectionWrapper>
        <div className="container">
          <MissionGrid>
            <MissionLeft>
              <MissionTitle>Misión y Objeto Social</MissionTitle>
              <MissionIntro>
                Nuestra misión es impulsar proyectos de infraestructura y
                servicios integrales mediante soluciones financieras y técnicas
                innovadoras que generen valor sostenible, a través de la
                consultoría en dictámenes técnicos, la elaboración de estudios
                financieros y la estructuración de proyectos de inversión.
              </MissionIntro>
            </MissionLeft>
            <MissionRight>
              <MissionTimeline>
                {missionSteps.map(step => (
                  <MissionTimelineItem key={step.step}>
                    <StepCircle>{step.step}</StepCircle>
                    <MissionStepContent>
                      <MissionStepTitle>{step.title}</MissionStepTitle>
                      <MissionStepText>{step.text}</MissionStepText>
                    </MissionStepContent>
                  </MissionTimelineItem>
                ))}
              </MissionTimeline>
            </MissionRight>
          </MissionGrid>
        </div>
      </MissionSectionWrapper>
      <TrayectoriaSectionWrapper>
        <div className="container">
          <TrayectoriaHeader>Nuestra Trayectoria</TrayectoriaHeader>
          <TrayectoriaStatsRow>
            <StatPill variant="primary">+18 Años de Experiencia</StatPill>
            <StatPill>+15 Proyectos de Transporte</StatPill>
            <StatPill>+10 Estudios de preinversión</StatPill>
          </TrayectoriaStatsRow>
          <TrayectoriaTimeline />
        </div>
      </TrayectoriaSectionWrapper>
    </>
  )
}

export default MissionTrayectoriaSectionNew
